import {
  AlertCircle,
  CircleOff,
  HelpCircle,
  MessageCircleQuestion,
} from 'lucide-react';

import { landingContent } from '@/constants/landing-content';

const { pain } = landingContent;

const iconMap = {
  MessageCircleQuestion,
  HelpCircle,
  CircleOff,
  AlertCircle,
} as const;

export function PainSection() {
  return (
    <section className="bg-muted/30 py-16 md:py-24">
      <div className="container mx-auto max-w-6xl px-4">
        <h2 className="text-foreground text-center text-3xl font-bold tracking-tight md:text-4xl">
          {pain.headline}
        </h2>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {pain.points.map((point, index) => {
            const Icon = iconMap[point.icon as keyof typeof iconMap];
            return (
              <div
                key={index}
                className="bg-background flex flex-col items-center rounded-lg p-6 text-center shadow-sm"
              >
                <div className="bg-accent flex h-12 w-12 items-center justify-center rounded-full">
                  <Icon className="text-primary h-6 w-6" />
                </div>
                <h3 className="text-foreground mt-4 font-semibold">
                  {point.title}
                </h3>
                <p className="text-muted-foreground mt-2 text-sm">
                  {point.description}
                </p>
              </div>
            );
          })}
        </div>

        <p className="text-muted-foreground mt-12 text-center text-lg italic md:text-xl">
          {pain.transition}
        </p>
      </div>
    </section>
  );
}
